import { render, staticRenderFns } from "./ActionIngresarABodegaRechazado.vue?vue&type=template&id=f60628ca&lang=pug"
import script from "./ActionIngresarABodegaRechazado.vue?vue&type=script&lang=js"
export * from "./ActionIngresarABodegaRechazado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports